const component = {

	/**
	 * Init component
     * 
     * @return {undefined}
	 */
	init: () => {

        window.theme = window.theme || {};
    	window.theme.file = component;
	},

    /**
	 * Get file extension from an url
     * 
     * @param {string} url File URL.
     * @param {object} regex Regex with file extensions.
     * @return {string} File extension.
	 */
    getExtension: (url, regex = /\.(jpe?g|png|gif|bmp|webp)/g) => {
        let fileExtension = '', m;
    
        while ((m = regex.exec(url)) !== null) {
            fileExtension = m[0];
        }
    
        return fileExtension;
    }
};

export default component;
